import React from "react"
import Body, { BodyProps } from "../../typography/Body"

export type TextCellProps = BodyProps & {
  value?: string | null
}

export default function TextCell({ value, ...props }: TextCellProps) {
  return (
    <Body
      color="dusk"
      fontWeight="medium"
      textAlign="center"
      px="0.5rem"
      {...props}
    >
      {value}
    </Body>
  )
}
